import { useEffect, useState } from "react";
import type { RadioChangeEvent, UploadProps } from 'antd';
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm, NoValidateForm } from "../../utility/validationRules";
import { FinancialProps, FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Button, Col, Modal, Radio, Row, Upload } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import {  getlabtaxInfo, modifyPayInfo, sendSMS, updateTaxInfo, uploadpayStatment } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { payTypes } from "../../constants";
import CustomTextArea from "../../components/_common/CustomTextArea";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { InfoText, UploadContainer } from "./style";
import {CheckCircleFilled,CloudUploadOutlined} from '@ant-design/icons';
import EditPaymentInfo from "./EditPaymentInfo";
import EditTaxInfo from "./EditTaxInfo";
import dayjs from "dayjs";
import { login } from "../../redux/reducers/authSlice";


export const UploadInvoiceDialog: React.FC<FinancialProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog,loadFinancialBalance,selectedLab,labTaxInfo}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(NoValidateForm) as any
    const myStore = useAppSelector((state) => state);
    const dispatch = useAppDispatch();

    const [isLoading,setIsLoading] = useState(false);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [base64,setBase64] = useState("");
    
    const [showVerificationRadio, setShowVerificationRadio] = useState(false);
    const [VerificationRadioVal, setVerificationRadioVal] = useState(true);
   
    const [showEditPaymentRadio, setShowEditPaymentRadio] = useState(false);    
    const [showEditPaymentForm, setShowEditPaymentForm] = useState(false);

    const [manualPaymentClick, setManualPaymentClick] = useState(false);
    const [showTaxCreate, setShowTaxCreate] = useState(false);

    const [inputValues, setInputValue] = useState({
        economicCode:labTaxInfo ? labTaxInfo.str_Economicode  : "",
        nationalCode:labTaxInfo ? labTaxInfo.str_TaxnationalCode  : " ",
        postalCode:labTaxInfo ? labTaxInfo.str_PostalCode  : " ",
        ownerNatioalCode:labTaxInfo ? labTaxInfo.str_TaxFullNameOwnernationalCode  : " ",
        address:labTaxInfo ? labTaxInfo.str_Address  : " ",
        telePhone:""
    });

    const [editInputValues, setEditInputValue] = useState({
        billNumber:payLoad.billNumber,
        date:payLoad.date,
        isGroup:false
    });
  
    function getFormValues(event: any) {       
        const { name, value } = event.target;       
        setInputValue({ ...inputValues, [name]: value });
        //console.log("parent:"+value);
    }

    function getEditFormValues(name:string,value:any) {       
        // const { name, value } = event.target; 
        // if (event.target.type == "checkbox") {
             setEditInputValue({ ...editInputValues, [name]: value });
        // }  
        // else{      
        //setEditInputValue({ ...editInputValues,billNumber:values.billNumber,date:values.date,isGroup:values.isGroup});
        //}
        //console.log("parent:"+value);
    }

    const onCancelForm =() =>{
        if(showEditPaymentForm)
    {
            setShowEditPaymentForm(false);
            setShowEditPaymentRadio(false);
            setShowVerificationRadio(false);
            setVerificationRadioVal(true);
    }
        else
            setShowDialog(false)
    }

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
        console.log(payLoad);  
        setBase64(""); 
        //getLabTaxInfo();
    },[payLoad])

    const onChangeVerificationRadio = (e: RadioChangeEvent) => {
        setVerificationRadioVal(e.target.value);

        if(e.target.value == false)
        {
            setShowEditPaymentRadio(true);
            setShowVerificationRadio(false);
        }
    }

    const onClickSystemPayment = ()=>{
        setShowVerificationRadio(true);
        setShowEditPaymentRadio(false);
        setVerificationRadioVal(true);
        setManualPaymentClick(false);
    }

    const onClickManualPayment =()=>{
        setManualPaymentClick(true);
    }
    const onChangeEditPaymentRadio = (e: RadioChangeEvent) =>{
        console.log(e.target.value);
        setShowEditPaymentForm(e.target.value);
        if(e.target.value == true)
            setShowEditPaymentForm(true);
    }

    // const getLabTaxInfo = () => {

    //     getlabtaxInfo(myStore.auth.userId)
    //     .then((result:any) => {
    //         console.log(result);
              
    //      })    
    //     .catch((error) => {
    //       console.log(error);
    //       errorNotify(error.response.data.errorMessage,undefined,5000)
    //     })

    // }


    // const getLabTaxInfo = () => {

    //     getlabtaxInfo(payLoad.labId)
    //     .then((result:any) => {
    //         console.log(result);
    //         setLabTaxInfo(result.data.data)
    //         setIsLoading(false);
    //         dispatch(login({loginType:"parsicuser",userId:myStore.auth.userId,userTitle:myStore.auth.userTitle,
    //         taxInfo:result.data.data,permission:myStore.auth.permission,
    //         manager:myStore.auth.manager
    //     ,int_minimumpayment:myStore.auth.int_minimumpayment}));  
            
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       errorNotify(error.response.data.errorMessage,undefined,5000)
    //     })

    // }

    const onSubmitForm = (e:any) => {
        e.preventDefault();
        setIsSubmiting(true)

       
        if(manualPaymentClick){
            uploadpayStatment(
                Number(payLoad.labId),
                myStore.auth.userId || 0,
                base64.replace("data:application/pdf;base64,",""),
                Number(payLoad.payId)
            ).then((result:any) => {
                sucessNotify("اطلاعات با موفقیت ثبت شد",undefined,5000)
                onCancel();
                setIsSubmiting(false)
            })
            .catch((error) => {
              console.log(error);
              setIsSubmiting(false)
              errorNotify(error.response.data.errorMessage,undefined,5000)
            })
        }
        else{
            if(VerificationRadioVal && !showTaxCreate){
                setShowTaxCreate(true);
                setIsSubmiting(false);
                setShowEditPaymentForm(false);
             }
             else if(showTaxCreate){
                _modifyPayInfo(editInputValues.isGroup?0:payLoad.labId,editInputValues.isGroup? payLoad.payId:0,editInputValues.billNumber,editInputValues.date);
                loadFinancialBalance(selectedLab?Number(selectedLab):0 );
            }
           else if(showEditPaymentForm){
               _modifyTaxInfo(payLoad.labId,inputValues);
               setShowTaxCreate(true);
               setShowEditPaymentForm(false);

           }
           else if(!showEditPaymentForm){
               _sendSMS(payLoad.labId);
           }
        }
    }

    const _modifyTaxInfo = (labId:number,values:any) => {
        updateTaxInfo(labId,values.economicCode,values.nationalCode,values.postalCode,
            values.ownerNatioalCode,values.address,values.telePhone)
        .then((result:any) => {
            if(result.status == 200) {
                setIsSubmiting(false);
                //getlabtaxInfo();
            }
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }



    
    const _modifyPayInfo = (labId:number,payId:number,billId:string,date:any) =>{
        modifyPayInfo(labId,payId,billId,date)
        .then((result:any) => {
            if(result.status == 200)
                sucessNotify("فاکتور ایجاد شد.");
                setIsSubmiting(false);
                setShowDialog(false);
                console.log(result);


        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }

    const _sendSMS = (labId:number) => {
        sendSMS(labId)
        .then((result:any) => {
            if(result.status == 200)
             setIsLoading(false);
             setIsSubmiting(false);
             sucessNotify("پیامکی جهت ویرایش اطلاعات به آزمایشگاه ارسال شد.");
             setShowDialog(false)

        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })
    }


    const uploadProps: UploadProps = {
        action: '',
        listType: 'text',
        beforeUpload(file) {

          return new Promise(resolve => {

            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function () {
                console.log(reader.result)

                if (reader.result){
                    setBase64(reader.result?.toString().replace('data:application/x-msdownload;base64,',''));
                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                errorNotify("خطا در بارگذاری فایل",undefined,5000)
            };
          });
        },
      };

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
            >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}
                {isLoading === false && labTaxInfo &&(

                    <FormContainer title="آپلود فاکتور" onSubmit={onSubmitForm} onCancel={onCancelForm} isLoading={isLoading} isSubmiting={isSubmiting} >
                     { showEditPaymentForm==false && showTaxCreate==false &&
                     (<>  
                        <Row>
                            <InfoText>کد ملی: { labTaxInfo.str_TaxnationalCode ? labTaxInfo.str_TaxnationalCode  : "تعریف نشده"}</InfoText>
                        </Row>
                        <Row>
                            <InfoText>کد اقتصادی:   {labTaxInfo.str_Economicode ? labTaxInfo.str_Economicode  : "تعریف نشده"}</InfoText>
                        </Row>
                        <Row>
                            <InfoText>نام کامل موسسه: { labTaxInfo.str_TaxFullNameOwnernationalCode ? labTaxInfo.str_TaxFullNameOwnernationalCode  : "تعریف نشده"}</InfoText>
                        </Row>
                        <Row>
                            <InfoText>کد پستی: {labTaxInfo.str_PostalCode ? labTaxInfo.str_PostalCode  : "تعریف نشده"}</InfoText>
                        </Row>
                        <Row>
                            <InfoText>آدرس پستی: {labTaxInfo.str_Address ? labTaxInfo.str_Address  : "تعریف نشده"}</InfoText>
                        </Row>

                        <Row>
                            <UploadContainer>
                                <Upload {...uploadProps}>
                                    <Button onClick={onClickManualPayment} icon={<CloudUploadOutlined />}> آپلود فاکتور دستی </Button>
                                </Upload>
                                <Button onClick={onClickSystemPayment} icon={<CloudUploadOutlined />}> آپلود فاکتور سیستمی </Button>
                                <div>
                                    {base64 !== "" ? <CheckCircleFilled style={{color:"green"}}/>  : undefined}
                                </div>
                            </UploadContainer>
                        </Row>
                       {showVerificationRadio && (
                         <Row style={{paddingTop:'15px'}}>
                         <Col lg={16} md={16} sm={16} xs={16}>
                             <span> آیا اطلاعات صحیح است؟
                             </span>                            
                         </Col>
                         <Col lg={8} md={8} sm={8} xs={8}>
                             <Radio.Group 
                             onChange={onChangeVerificationRadio} value={VerificationRadioVal}>
                             <div>
                                 <Radio value={true}>بله</Radio>
                                 <Radio value={false}>خیر</Radio>
                             </div> 
                                 
                                 
                             </Radio.Group>
                         </Col>
                     </Row>
                       )}

                        {showEditPaymentRadio && (
                         <Row style={{paddingTop:'15px'}}>
                         <Col lg={16} md={16} sm={16} xs={16}>
                             <span> آیا می خواهید اطلاعات را ویرایش کنید؟
                             </span>                            
                         </Col>
                         <Col lg={8} md={8} sm={8} xs={8}>
                             <Radio.Group 
                             onChange={onChangeEditPaymentRadio} value={showEditPaymentForm}>
                             <div>
                                 <Radio value={true}>بله</Radio>
                                 <Radio value={false}>خیر</Radio>
                             </div> 
                                 
                                 
                             </Radio.Group>
                         </Col>
                     </Row>
                       )}

                        </> 
                     )
                     }
                     { showEditPaymentForm==true && 
                         <EditPaymentInfo getFormValues={getFormValues} labTaxInfo={labTaxInfo} />
                     }

                    {showTaxCreate && <EditTaxInfo getEditFormValues={getEditFormValues} billNumber={payLoad.billNumber} date={payLoad.date}/>}
                        </FormContainer>

                )}
            </>
            
        </Modal>
    )
}